export default "__VITE_ASSET__BYHPC6u0__"